import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "toolkit/features/user";
import useUser from "libs/hooks/useUser";
import { RootState } from "toolkit/store";
import { GUEST_ROLE } from "../utils/constants";
import { reportLog } from "../utils/logs";

const useUserAddress = () => {
  const user = useUser();

  const dispatch = useDispatch<any>();
  const { data, loading } = useSelector((state: RootState) => state.user);
  const [address, setAddress] = useState(data?.payload?.address || []);

  useEffect(() => {
    if (user && user?.role !== GUEST_ROLE && !data?.payload) {
      dispatch(getUserData({ id: user?._id }))
        .then((res) => {
          setAddress(res?.payload?.payload?.address || []);
        })
        .catch((error) => {
          reportLog({
            error: error,
            location: "useUserAddress->useEffect[22]",
            body: data?.payload,
          });
        });
    }
  }, [user]);

  if (user?.role === GUEST_ROLE) {
    return { address: [], loading: false };
  }

  return { address, loading };
};

export default useUserAddress;
